import { defineMessages } from 'react-intl';

export const generalNoteTypeMessages = defineMessages({
  summary: {
    id: 'instanceNoteTypes.summary',
    defaultMessage: 'Summary',
  },
  generalNote: {
    id: 'instanceNoteTypes.generalNote',
    defaultMessage: 'Notes',
  },
  'Language note': {
    id: 'instanceNoteTypes.languageNote',
    defaultMessage: 'Language note',
  },
  'Linking Entry Complexity note': {
    id: 'instanceNoteTypes.linkingEntry',
    defaultMessage: 'Linking entry',
  },
  'Reproduction note': {
    id: 'instanceNoteTypes.reproduction',
    defaultMessage: 'Reproduction',
  },
});

export const secondaryNoteTypesMessages = defineMessages({
  'Participant or Performer note': {
    id: 'instanceNoteTypes.participantPerformer',
    defaultMessage: 'Participant/performer',
  },
  'Biographical or Historical Data': {
    id: 'instanceNoteTypes.biographicalHistoricalData',
    defaultMessage: 'Biographical or historical data',
  },
  'Date / time and place of an event note': {
    id: 'instanceNoteTypes.dateLocation',
    defaultMessage: 'Date and location',
  },
  'Target Audience note': {
    id: 'instanceNoteTypes.targetAudience',
    defaultMessage: 'Target audience',
  },
  'Geographic Coverage note': {
    id: 'instanceNoteTypes.geographicCoverage',
    defaultMessage: 'Geographic coverage',
  },
  bibliographicNote: {
    id: 'instanceNoteTypes.bibliographicNote',
    defaultMessage: 'Bibliographic notes',
  },
  'Issuing Body note': {
    id: 'instanceNoteTypes.issuingBody',
    defaultMessage: 'Issuing body',
  },
  'Dissertation note': {
    id: 'instanceNoteTypes.dissertation',
    defaultMessage: 'Dissertation',
  },
  localNote: {
    id: 'instanceNoteTypes.localNote',
    defaultMessage: 'Local notes',
  },
  'Information related to Copyright Status': {
    id: 'instanceNoteTypes.copyrightStatus',
    defaultMessage: 'Copyright status',
  },
  'Terms Governing Use and Reproduction note': {
    id: 'instanceNoteTypes.termsOfUse',
    defaultMessage: 'Terms of use',
  },
  'Preferred Citation of Described Materials note': {
    id: 'instanceNoteTypes.preferredCitationOfDescribedMaterials',
    defaultMessage: 'Preferred citation of described materials',
  },
  'Former Title Complexity note': {
    id: 'instanceNoteTypes.formerTitle',
    defaultMessage: 'Former title',
  },
  contentNote: {
    id: 'instanceNoteTypes.contentNote',
    defaultMessage: 'Content notes',
  },
  'Numbering peculiarities note': {
    id: 'instanceNoteTypes.numberingPeculiarities',
    defaultMessage: 'Numbering peculiarities',
  },
  'Supplement note': {
    id: 'instanceNoteTypes.supplement',
    defaultMessage: 'Supplement',
  },
  'Supplemental note': {
    id: 'instanceNoteTypes.supplemental',
    defaultMessage: 'Supplement',
  },
  'Additional Physical Form Available note': {
    id: 'instanceNoteTypes.additionalForms',
    defaultMessage: 'Additional forms',
  },
  'Original Version note': {
    id: 'instanceNoteTypes.originalVersion',
    defaultMessage: 'Original version',
  },
  'Source of Description note': {
    id: 'instanceNoteTypes.sourceOfDescription',
    defaultMessage: 'Source of description',
  },
  'Data quality note': {
    id: 'instanceNoteTypes.dataQuality',
    defaultMessage: 'Data quality',
  },
  'Type of computer file or data note': {
    id: 'instanceNoteTypes.computerFileType',
    defaultMessage: 'Computer file type',
  },
  'Accessibility note': {
    id: 'instanceNoteTypes.accessibility',
    defaultMessage: 'Accessibility',
  },
  'System Details note': {
    id: 'instanceNoteTypes.systemDetail',
    defaultMessage: 'System detail',
  },
  'Entity and Attribute Information note': {
    id: 'instanceNoteTypes.entityAndAttributeInformation',
    defaultMessage: 'Entity and attribute information',
  },
  'Cumulative Index / Finding Aides notes': {
    id: 'instanceNoteTypes.findingAids',
    defaultMessage: 'Finding Aids notes',
  },
  'Information About Documentation note': {
    id: 'instanceNoteTypes.informationAboutDocumentation',
    defaultMessage: 'Information about documentation',
  },
  'Immediate Source of Acquisition note': {
    id: 'instanceNoteTypes.immediateSourceOfAcquisition',
    defaultMessage: 'Immediate source of acquisition',
  },
  'Ownership and Custodial History note': {
    id: 'instanceNoteTypes.ownershipAndCustodialHistory',
    defaultMessage: 'Ownership and custodial history',
  },
  'Location of Originals / Duplicates note': {
    id: 'instanceNoteTypes.locationOfOriginals',
    defaultMessage: 'Location of originals',
  },
  'Location of Other Archival Materials note': {
    id: 'instanceNoteTypes.locationOfOtherArchivalMaterials',
    defaultMessage: 'Location of other archival materials',
  },
  'Exhibitions note': {
    id: 'instanceNoteTypes.exhibitions',
    defaultMessage: 'Exhibitions',
  },
});

export const restrictionOnAccessModeNote = {
  labelKey: 'Restrictions on Access note',
};
